module.exports = __webpack_public_path__ + "media/theme/reco-049eb17a.png";